import React, { memo, useState } from 'react'
import "./FormMessageContent.scss"
import { FormMessageKeys, MessageSources } from 'constants/MessageConstants';
import dayjs from 'utils/dayjs';
import { uepClient } from 'uepClient';
import { getFileScenario } from 'constants/UserConstants';

function FormMessageContent(props) {
    const { message } = props;
    const [showAll, setShowAll] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(true)
    const [ImageUrl, setImageUrl] = useState(null)
    const [fetchImageError, setfetchImageError] = useState(false)
    var startDateTime;
    var endDateTime;

    const displayImage = (key, value) => {
        if (ImageUrl == null) {
            uepClient()
                .get(`/file?fileId=${value}&scenario=${getFileScenario.CUSTOMER_QUERY}`)
                .then((result) => {
                    setImageUrl(result.data.fileUrl)
                    setIsImageLoading(false)
                })
                .catch((error) => {
                    setIsImageLoading(false)
                    setImageUrl("")
                    setfetchImageError(true)
                    console.error(error.message);
                });
        }
        return (
            isImageLoading ?
                <>loading....</>
                :
                <>
                    {fetchImageError ?
                        <>issue to show image </>
                        :
                        <>
                            <a href={ImageUrl} target='_blank'>
                                <img src={ImageUrl} className="show-img-area" />
                            </a>

                        </>}
                </>
        )
    }


    if (message.source == MessageSources.CUSTOMER) {
        var messageFormObj
        try {
            messageFormObj = JSON.parse(message.message)
        } catch (err) {
            console.log("err", err, messageFormObj)
        }
        return (
            <div className="custom-message" data-testid="text-message-content">
                {messageFormObj ?
                    <>
                        {
                            Object.entries(messageFormObj).map(([key, value]) => {
                                if (key == FormMessageKeys.VIEWNAME) {
                                    return null
                                } else if (key === FormMessageKeys.STARTDATETIME || key === FormMessageKeys.ENDDATETIME) {
                                    if (key === FormMessageKeys.STARTDATETIME) {
                                        startDateTime = dayjs(value).format("MMM DD, YYYY | h:mm A")
                                    }
                                    if (key === FormMessageKeys.ENDDATETIME) {
                                        endDateTime = dayjs(value).format(" to h:mm A")
                                    }
                                    if (startDateTime && endDateTime) {
                                        return (
                                            <div className='form-contol'>
                                                <label >Selected Date & Time: </label>
                                                <input type="text" defaultValue={startDateTime + endDateTime} readOnly className={"inut-area-chacked"} />
                                            </div>
                                        )
                                    }
                                    else return null
                                } else if (key == FormMessageKeys.QUERY) {
                                    return (
                                        <div className='form-contol'>
                                            <label >User Query:</label>
                                            {value.length > 100 ? (
                                                <div className={"text-area"}>
                                                    {showAll ? (
                                                        <div>
                                                            {value}
                                                            <span onClick={() => setShowAll(false)} className="read-more-btn"> Read Less...</span>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            {value.substring(0, 100).concat(" ")}
                                                            <span onClick={() => setShowAll(true)} className="read-more-btn">Read More...</span>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                value
                                            )}
                                        </div>
                                    );
                                } else if (key == FormMessageKeys.IMAGEID) {
                                    return (
                                        <div className='form-contol'>
                                            {value != null ?
                                                <>
                                                    <label>Attached Image:</label>
                                                    {displayImage(key, value)}
                                                </>
                                                :
                                                null}
                                        </div>
                                    )
                                }
                                else {
                                    return (
                                        <div className='form-contol'>
                                            <label>{key}:</label>
                                            <span>{value}</span>
                                        </div>
                                    )
                                }
                            })
                        }
                    </>
                    :
                    <div className="message-text">{message.message}</div>
                }

            </div>
        )
    } else {
        return (
            <div className="custom-message" data-testid="text-message-content">
                <div className="message-text">{message.message}</div>
            </div>
        )
    }

}

export default memo(FormMessageContent)